<div class="d-flex" style="padding-top: 10px; overflow-x: auto;">
  <div class="position-relative photo-wrapper " *ngFor="let photo of photos; let i = index">
    <img class="card-img" loading="lazy" alt="{{photo.name}}" src="{{photo.url | getFileUrl}}">
    <span class="position-absolute rounded-circle close-out" (click)="delete(i)" *ngIf="canDelete">
      <button type="button" class="close-btn">X</button>
    </span>
  </div>
</div>
